export const topbarBadgeLinkStyle = {
  display: "inline-flex",
  alignItems: "center",
  height: "60px",
  marginRight: "12px",
  textDecoration: "none",
};

export const topbarBadgeClassName = "p-2 d-flex align-items-center";
